import React, { useEffect, useState } from 'react';
import './Novedades.css';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ReactComponent as FlechaDerechaIcon } from '../assets/flecha derecha.svg';

const Novedades = () => {
  const navigate = useNavigate();
  const [noticias, setNoticias] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchNoticias = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/noticias/?page_size=6`);
        const data = response.data;
        setNoticias(data.results || data);
        setError(null);
      } catch (err) {
        console.error('Error cargando noticias:', err);
        setError('Error al cargar las noticias');
      } finally {
        setLoading(false);
      }
    };

    fetchNoticias();
  }, []);

  useEffect(() => {
    if (loading) {
      return undefined;
    }

    const targets = document.querySelectorAll('.novedades-section .reveal-on-scroll:not(.visible)');
    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -25px 0px' }
    );

    targets.forEach((element) => observer.observe(element));

    return () => observer.disconnect();
  }, [loading, noticias]);

  const noticiasAMostrar = noticias.slice(0, 3);

  const handleLeerMas = (id) => {
    navigate(`/novedades/${id}`);
  };

  const formatFecha = (fechaString) => {
    const fecha = new Date(fechaString);
    return fecha.toLocaleDateString('es-AR', {
      day: '2-digit',
      month: 'long',
      year: 'numeric'
    });
  };

  const extractText = (html) => {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || '';
  };

  if (loading) {
    return (
      <section className="novedades-section">
        <div className="novedades-container">
          <h2 className="section-title">Novedades</h2>
          <div style={{ textAlign: 'center', padding: '2rem' }}>
            <p>Cargando noticias...</p>
          </div>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="novedades-section">
        <div className="novedades-container">
          <h2 className="section-title">Novedades</h2>
          <div style={{ textAlign: 'center', padding: '2rem', color: '#d32f2f' }}>
            <p>{error}</p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="novedades-section">
      <div className="novedades-container">
        <div className="novedades-header reveal-on-scroll">
          <div>
            <p className="novedades-kicker">ULTIMAS NOTICIAS</p>
            <h2 className="section-title">Novedades y Obras</h2>
          </div>
          <button className="ver-todas-link" onClick={() => navigate('/novedades')}>
            Ver todas las noticias
          </button>
        </div>

        {noticias.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '2rem' }}>
            <p>No hay noticias disponibles</p>
          </div>
        ) : (
          <div className="noticias-grid">
            {noticiasAMostrar.map((noticia) => (
              <article key={noticia.id} className="noticia-card reveal-on-scroll">
                <div className="noticia-imagen">
                  <img
                    src={noticia.imagen_principal_thumbnail || noticia.imagen_principal_url || '/placeholder-image.jpg'}
                    alt={noticia.titulo}
                    loading="lazy"
                    onError={(e) => {
                      e.target.src = '/placeholder-image.jpg';
                    }}
                  />
                </div>
                <div className="noticia-contenido">
                  <span className="noticia-categoria">{noticia.categoria?.nombre || 'GESTION'}</span>
                  <p className="noticia-fecha">{formatFecha(noticia.fecha_publicacion)}</p>
                  <h3 className="noticia-titulo">{noticia.titulo}</h3>
                  <p className="noticia-descripcion">
                    {(() => {
                      const textoLimpio = extractText(noticia.contenido || '');
                      return textoLimpio.length > 140 ? `${textoLimpio.substring(0, 140)}...` : textoLimpio;
                    })()}
                  </p>
                  <button className="leer-mas-btn" onClick={() => handleLeerMas(noticia.id)}>
                    <span>Leer mas</span>
                    <FlechaDerechaIcon className="leer-mas-icon" aria-hidden="true" focusable="false" />
                  </button>
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default Novedades;
